import { render, staticRenderFns } from "./basic-confirm-dialog.vue?vue&type=template&id=35ea9e96"
import script from "./basic-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./basic-confirm-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports